import React, { useState, useRef, useEffect } from "react";
import { Calendar1 } from "lucide-react";
import CalendarPopup from "../form/CalendarPopup";
import toast from "react-hot-toast";

const CalendarPopover = ({ value, onApply }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const handleOnApply = (range) => {
    const { start_date, end_date } = range || {};

    if (!start_date || !end_date || start_date === end_date) {
      toast.error("Please select both start and end dates");
      return;
    }

    onApply(range);
    setOpen(false);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative  block z-60" ref={ref}>
      {/* Trigger */}
      <button
        onClick={() => {
          setOpen((prev) => !prev);
        }}
        className="border border-gray-200 rounded-md p-[13px] bg-white hover:bg-gray-50 transition"
      >
        <Calendar1 size={18} />
      </button>

      {/* Popover */}
      {open && (
        <>
          {/* Mobile center overlay */}
          <div className="fixed inset-0 z-50 mt-48 flex items-start justify-center pt-20  sm:hidden">
            <CalendarPopup
              variant="range"
              value={value}
              onApply={handleOnApply}
              onClose={() => setOpen(false)}
            />
          </div>

          {/* Desktop popover */}
          <div className="hidden sm:block absolute right-0 mt-2 z-50">
            <CalendarPopup
              variant="range"
              value={value}
              onApply={handleOnApply}
              onClose={() => setOpen(false)}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CalendarPopover;
